import { SourceSheet } from '../refresh-data/source-sheet';
import { ColumnMapping } from './column-mapping.model';

export interface TableConfig {
  columnMappings: ColumnMapping[];
  sheetType?: SourceSheet;
}

export interface TableInfo {
  rowIndex: number;
  columnIndex: number;
  columnCount: number;
  showTotals: boolean;
  rowCount: number;
}
